import React, { useEffect } from "react";
import Center from "../../../../widget/common/ui/Center";
import Div from "../../../../widget/common/ui/Div";
import AppTranslation from "../../../../service/app_translation/AppTranslation";
import { Col } from "react-bootstrap";
import { SignupCompanyLogo } from "../widget/SignupWidgets";
import { SpacingHeight } from "../../../../widget/common/ui/Spacing";
import { TextBlock } from "../../../../widget/common/ui/Text";
import {
  SignupChangeEmailField,
  SignupChangePhoneField,
} from "./widget/SignupAccountVerificationChangeTextfields";
import StorageKeys from "../../../../const/StorageKeys";
import SessionStorage from "../../../../service/storage/SessionStorage";
import UtilityHelper from "../../../../service/utilities/UtilityHelper";
import { appRoutes } from "../../../../routes/routes";
import { navigate } from "../../../../service/navigation/Navigation";
import { SignupAccountVerificationContextImport } from "../../../../provider/onboarding/signup/account_verification/SignupAccountVerificationContextProvider";

const SignupAccountVerificationChangeContent = (props: { type: number }) => {
  const type: number = props.type;

  const { verificationType } = SignupAccountVerificationContextImport();

  const checkVericationSession = () => {
    const verificationSession = SessionStorage.getValue(
      StorageKeys.signup_verification_detail
    );
    if (UtilityHelper.isEmpty(verificationSession)) {
      navigate(appRoutes.routeNameLogin, { replace: true });
    }
  };

  useEffect(() => {
    checkVericationSession();
  }, []);

  return (
    <Div className="h-100 d-center">
      <Div>
        <Center>
          <SignupCompanyLogo
            title={AppTranslation.text("change_verification_details")}
          />
        </Center>
        <Col xs={12} className="mx-auto text-center">
          <TextBlock
            center={true}
            fontSize="16_17"
            fontName="book"
            textColor="theme-label"
          >
            {AppTranslation.text(
              verificationType === "phone"
                ? "please_enter_new_mobile_number"
                : "please_enter_new_email_address"
            )}
          </TextBlock>
        </Col>
        <SpacingHeight value={type === 1 ? 35 : type === 2 ? 48 : 45} />
        <form autoComplete="off">
          {verificationType === "phone" ? (
            <SignupChangePhoneField />
          ) : (
            <SignupChangeEmailField />
          )}
        </form>
        <SpacingHeight value={type === 3 ? 100 : 0} />
      </Div>
    </Div>
  );
};

export default SignupAccountVerificationChangeContent;
